export function isSelectionWithinContainer(selection: Selection, element: HTMLElement): boolean {
    if (selection.rangeCount === 0) {
        return false;
    }

    return element.contains(selection.anchorNode) && element.contains(selection.focusNode);
}
